import { POSTWithoutRedirect } from "./API";

const BASE = "/api/v1/identity/users/email_auth";

export const checkEmail = (email, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/check_email`, { email }, onSuccess, onError, false);

export const verifyOtp = (email, otp, flow, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/verify_otp`, { email, otp, flow }, onSuccess, onError, false);

export const signInWithEmail = (email, password, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/sign_in_with_email`, { email, password }, onSuccess, onError, false);

export const sendRegistrationOtp = (email, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/send_registration_otp`, { email }, onSuccess, onError, false);

export const registerWithEmail = (email, otp, password, profile, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/register_with_email`, { email, otp, password, ...profile }, onSuccess, onError, false);

export const sendSetPasswordOtp = (email, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/send_set_password_otp`, { email }, onSuccess, onError, false);

export const setPasswordWithOtp = (email, otp, password, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/set_password_with_otp`, { email, otp, password }, onSuccess, onError, false);

export const sendPasswordResetOtp = (email, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/send_password_reset_otp`, { email }, onSuccess, onError, false);

export const resetPasswordWithOtp = (email, otp, password, onSuccess, onError) =>
  POSTWithoutRedirect(`${BASE}/reset_password_with_otp`, { email, otp, password }, onSuccess, onError, false);
